/* Free Rep+ offer: real cart logic for /pages/try-rep and /pages/rep-offer.
   Prices are set by Shopify (offer products + discount FIRSTTUB), never by this script. */
(function () {
  var REP = 49722209763399, FORT = 49722217988167, CODE = 'FIRSTTUB';
  var CHECKOUT = '/discount/' + CODE + '?redirect=%2Fcheckout';
  var page = document.body.getAttribute('data-rep-page');
  function $(id) { return document.getElementById(id); }
  function show(el, on) { if (el) el.classList.toggle('is-hidden', !on); }
  function getJSON(url) { return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function cart() { return getJSON('/cart.js'); }
  function line(c, id) { for (var i = 0; i < c.items.length; i++) if (c.items[i].variant_id === id) return c.items[i]; return null; }
  function available(handle) { return getJSON('/products/' + handle + '.js').then(function (p) { return !!(p.variants && p.variants[0] && p.variants[0].available); }).catch(function () { return true; }); }
  // One call per funnel step: Meta custom event (no clash with the Shopify Meta app's standard events),
  // Microsoft Clarity event + tag (for session filtering), and a Klaviyo onsite event.
  function track(name, props) {
    props = props || {};
    try { if (window.fbq) window.fbq('trackCustom', name, props); } catch (e) {}
    try { if (window.clarity) { window.clarity('event', name); window.clarity('set', 'rep_offer_step', name); } } catch (e) {}
    try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Rep Offer ' + name, props]); } catch (e) {}
  }

  // Exactly one offer tub in the cart. Reuse an existing line, never increment it.
  function ensureOne(id) {
    return cart().then(function (c) {
      var l = line(c, id);
      if (!l) return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
      if (l.quantity !== 1) return post('/cart/change.js', { id: l.key, quantity: 1 });
    }).then(cart).then(function (c) {
      var l = line(c, id);
      if (!l || l.quantity !== 1) throw new Error('verify');
      return c;
    });
  }

  if (page === 'landing') {
    track('OfferLandingView', { source: new URLSearchParams(location.search).get('utm_content') || 'direct' });
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.js-claim'));
    var busy = false;
    function label(b) { return b.closest('.sticky') ? 'Claim' : 'Claim my first tub'; }
    function setAll(fn) { buttons.forEach(fn); }
    var PAUSED = 'This offer is temporarily unavailable. You can still <a href="/">visit our shop</a> or <a href="/pages/contact">contact us</a> for help.';
    available('replenish-plus-first-tub-offer').then(function (ok) {
      if (ok) return;
      setAll(function (b) { b.disabled = true; });
      document.querySelectorAll('.js-offer-state').forEach(function (el) { el.hidden = false; el.innerHTML = '<div class="msg msg--warn" role="status">' + PAUSED + '</div>'; });
    });
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        document.querySelectorAll('.js-err').forEach(function (x) { x.hidden = true; });
        setAll(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        btn.querySelector('.js-label').innerHTML = '<span class="spinner" aria-hidden="true"></span> Adding your tub…';
        track('OfferClaim');
        ensureOne(REP).then(function () {
          track('OfferRepAdded');
          location.href = '/pages/rep-offer';
        }).catch(function () {
          busy = false;
          setAll(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); b.querySelector('.js-label').textContent = label(b); });
          var box = btn.closest('.sticky') ? document.querySelector('#hero-cta .js-err') : (btn.parentNode.querySelector('.js-err') || document.querySelector('#hero-cta .js-err'));
          box.textContent = 'We couldn’t update your cart. Please try again.'; box.hidden = false;
          if (btn.closest('.sticky')) $('hero-cta').scrollIntoView({ block: 'center' });
        });
      });
    });

    // Sticky claim bar (mobile): only after the hero button scrolls away, hidden near the final CTA and footer.
    var sticky = $('sticky'), heroGone = false, finalIn = false;
    function syncSticky() {
      if (!sticky) return;
      var on = heroGone && !finalIn && !document.querySelector('dialog[open]');
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelector('button').tabIndex = on ? 0 : -1;
    }
    if ('IntersectionObserver' in window && sticky) {
      new IntersectionObserver(function (en) { heroGone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; syncSticky(); }).observe($('hero-cta'));
      var seen = new Map();
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { seen.set(x.target, x.isIntersecting); }); finalIn = Array.from(seen.values()).some(Boolean); syncSticky(); });
      io.observe($('final-cta')); io.observe($('footer'));
    }
    var dlg = $('label');
    if (dlg) {
      $('open-label').addEventListener('click', function () { dlg.showModal(); syncSticky(); });
      $('close-label').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('close', syncSticky);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    document.querySelectorAll('#faq .acc__btn').forEach(function (b) {
      b.addEventListener('click', function () { var open = b.getAttribute('aria-expanded') === 'true'; b.setAttribute('aria-expanded', String(!open)); $(b.getAttribute('aria-controls')).hidden = open; });
    });
  }

  if (page === 'addon') {
    var fortOK = true, busy2 = false;
    function render() {
      return cart().then(function (c) {
        var hasRep = !!line(c, REP), added = !!line(c, FORT);
        show($('empty'), !hasRep); show($('flow'), hasRep);
        if (!hasRep) return;
        show($('choices'), !added && fortOK);
        show($('onward'), added || !fortOK);
        show($('remove-fortify'), added);
        show($('after'), !added && fortOK);
        show($('fort-unavail'), !fortOK && !added);
        if (added) { $('fort-ok').textContent = 'Fortify is in your order.'; }
        show($('fort-ok'), added);
        $('sum').innerHTML = '<div><span>Rep+ first tub</span><b>$0.00</b></div>' + (added ? '<div><span>Fortify</span><b>$29.99</b></div>' : '') + '<div><span>Shipping</span><b>$11.00</b></div><div><span>Total before tax</span><b>' + (added ? '$40.99' : '$11.00') + '</b></div><div><span>Tax</span><b>At checkout</b></div>';
      });
    }
    function go() { track('OfferCheckout'); setTimeout(function () { location.href = CHECKOUT; }, 150); }
    track('FortifyOfferView');
    available('fortify-add-on-offer').then(function (ok) { fortOK = ok; return render(); }).catch(function () { show($('flow'), false); show($('empty'), true); });
    $('accept').addEventListener('click', function () {
      if (busy2) return;
      busy2 = true; show($('fort-err'), false);
      $('accept').disabled = true; $('decline').disabled = true;
      var orig = $('accept').innerHTML;
      $('accept').innerHTML = '<span class="spinner" aria-hidden="true"></span> Adding Fortify…';
      track('FortifyAccept');
      ensureOne(FORT).then(go).catch(function () {
        busy2 = false; $('accept').innerHTML = orig; $('accept').disabled = false; $('decline').disabled = false;
        $('fort-err').textContent = 'We couldn’t update your cart. Please try again.'; show($('fort-err'), true);
      });
    });
    $('decline').addEventListener('click', function () { if (busy2) return; track('FortifyDecline'); go(); });
    $('go-checkout').addEventListener('click', go);
    $('remove-fortify').addEventListener('click', function () {
      cart().then(function (c) { var l = line(c, FORT); return l ? post('/cart/change.js', { id: l.key, quantity: 0 }) : null; }).then(render);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { busy2 = false; $('accept').disabled = false; $('decline').disabled = false; $('accept').innerHTML = '<span class="js-label">Yes, add Fortify for $29.99</span>'; render(); } });
  }
})();
